import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
import MediationRoundedIcon from "@mui/icons-material/MediationRounded";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import DataThresholdingOutlinedIcon from "@mui/icons-material/DataThresholdingOutlined";
import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import BrowserUpdatedOutlinedIcon from "@mui/icons-material/BrowserUpdatedOutlined";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";

import { DATA_SOURCE, ENTITY, OBJECT_TYPE } from "../../util/Data/DataModeling";

const navDatasets = {
  id: "Data-Sources",
  name: DATA_SOURCE.plural,
  group: "Modeling",
  icon: <SourceOutlinedIcon fontSize="large" />,
  link: "data-sources",
  showInMenu: true,
  objectType: OBJECT_TYPE?.["DataSource"],
};

const navEntities = {
  id: "Data-Modeling",
  name: "Entities",
  group: "Modeling",
  icon: <MediationRoundedIcon fontSize="large" />,
  link: "entities",
  showInMenu: true,
  objectType: OBJECT_TYPE?.["Entity"],
};

const LINK_OBJECT_TYPE = {
  [navDatasets?.link]: { ...DATA_SOURCE, objectType: OBJECT_TYPE?.["DataSource"] },
  [navEntities?.link]: { ...ENTITY, objectType: OBJECT_TYPE?.["Entity"] },
};

const navScheduledJobs = {
  id: "Data-Pipelines",
  name: "Data Pipelines",
  group: "Modeling",
  icon: <AccountTreeOutlinedIcon fontSize="large" />,
  link: "scheduled-jobs",
  showInMenu: true,
};

const navDataScience = {
  id: "Data-Science",
  name: "Data Analytics",
  group: "Modeling",
  icon: <DataThresholdingOutlinedIcon fontSize="large" />,
  link: "data-analytics",
  showInMenu: true,
};

const navDataAI = {
  id: "Data-AI",
  name: "Data AI",
  group: "Modeling",
  icon: <AutoAwesomeIcon fontSize="large" />,
  link: "data-ai",
  showInMenu: true,
};

const navMachineLearning = {
  id: "Machine-Learning",
  name: "Machine Learning",
  group: "Modeling",
  icon: <TipsAndUpdatesOutlinedIcon fontSize="large" />,
  link: "machine-learning",
  showInMenu: true,
};

const navDataConnection = {
  id: "Data-Connections",
  name: "Data Connections",
  group: "Modeling",
  icon: <AddchartOutlinedIcon fontSize="large" />,
  link: "data-connections",
  showInMenu: true,
};

const navDataExplorer = {
  id: "Data-Explorer",
  name: "SQL Explorer",
  group: "Modeling",
  icon: <TableChartOutlinedIcon fontSize="large" />,
  link: "data-explorer",
  showInMenu: true,
};

const navQuickImport = {
  id: "Quick-Import",
  name: "Quick Import",
  group: "Modeling",
  icon: <BrowserUpdatedOutlinedIcon fontSize="large" />,
  link: "load-data",
  showInMenu: true,
};

const navManageSchemas = {
  id: "Manage-Schemas",
  name: "Manage Schemas",
  group: "Workspace",
  icon: <SchemaOutlinedIcon fontSize="large" />,
  link: "manage-schema",
};

const navImportWorkspace = {
  id: "Import-Workspace-Configuration",
  name: "Import Workspace Configuration",
  group: "Workspace",
  icon: <SystemUpdateAltOutlinedIcon fontSize="large" />,
  link: "import-workspace",
};

const navExportWorkspace = {
  id: "Export-Workspace-Configuration",
  name: "Export Workspace Configuration",
  group: "Workspace",
  icon: <IosShareOutlinedIcon fontSize="large" />,
  link: "export-workspace",
};

const navQualityDashboard = {
  id: "Data-Quality-Dashboard",
  name: "Data Quality Dashboard",
  group: "Dashboard",
  icon: <PollOutlinedIcon fontSize="large" />,
  link: "dqm",
};

const navAppHosting = {
  id: "App-Hosting",
  name: "App Hosting",
  group: "Modeling",
  icon: <CloudDoneOutlinedIcon fontSize="large" />,
  link: "app-hosting",
  showInMenu: true,
};

// Common Navigation Detail object
const navigationDetails = [
  navDatasets,
  navEntities,
  navScheduledJobs,
  navDataScience,
  navDataAI,
  navMachineLearning,
  navDataConnection,
  navDataExplorer,
  navQuickImport,
  navManageSchemas,
  navImportWorkspace,
  navExportWorkspace,
  navQualityDashboard,
  navAppHosting,
];

// Navigation Menu
const navOptions = navigationDetails.filter(({ showInMenu }) => showInMenu);

export {
  LINK_OBJECT_TYPE,
  navDatasets,
  navEntities,
  navScheduledJobs,
  navDataScience,
  navDataAI,
  navMachineLearning,
  navDataConnection,
  navDataExplorer,
  navQuickImport,
  navManageSchemas,
  navImportWorkspace,
  navExportWorkspace,
  navQualityDashboard,
  navAppHosting,
  navOptions,
};
